import React from 'react';
import { fullPageLoadingIndicator } from '@magento/venia-ui/lib/components/LoadingIndicator';
import { useDesignTeam } from './useDesignTeam';
import DesignTeamMember from './designTeamMember';
import CmsBlock from 'src/components/Cms/cmsBlock';
import CMSPage from '../../components/Cms/cms';
import { AppBodyLayout } from '../../components';

var DesignTeam = function DesignTeam() {
  var _useDesignTeam = useDesignTeam(),
      loading = _useDesignTeam.loading,
      error = _useDesignTeam.error,
      data = _useDesignTeam.data;

  if (loading) return fullPageLoadingIndicator;
  var designTeamMembers = data === null || data === void 0 ? void 0 : data.map(function (item, indx) {
    return React.createElement(DesignTeamMember, {
      key: indx,
      member: item
    });
  });
  return React.createElement(React.Fragment, null, React.createElement(CMSPage, {
    identifier: "designers"
  }));
};

export default DesignTeam;